import { JWTClaims, rolesEnumSchema } from "@mindlercare/schema";

export const blockLoginBasedOnRole = (claims: JWTClaims) => {
  const acceptedRoles: string[] = [
    rolesEnumSchema.Values.Psychologist,
    rolesEnumSchema.Values.Admin,
    rolesEnumSchema.Values.hqEmployee,
  ];
  return !(
    "roles" in claims &&
    claims.roles.some((role) => acceptedRoles.includes(role.name))
  );
};
